import { CInput, CInputGroup, CInputGroupPrepend } from '@coreui/react';
import * as React from 'react';
import './KLoginConfInput.css';


interface IProps {
    title: string,
    label: string;

    onChange: (value:string) => void;
}

interface IState {
    text: string
}

export class KLoginConfInput extends React.Component<IProps, IState> {
    public constructor(props: any) {
        super(props);        
        this.state = { text: this.props.label }
    }
    
    onLabelChange = (event) => {
        this.setState({ text: event.target.value }, () => { this.props.onChange(this.state.text) }) 
    }

    render() {
        return (
            <div className="KLoginConfInput">
                <CInputGroup size="sm">
                    <CInputGroupPrepend >{this.props.title}</CInputGroupPrepend>
                    <CInput value={this.state.text} onChange={this.onLabelChange} />
                </CInputGroup>
            </div>
        )
    }
}